const zipByRepetition = (sequence) => {
  return sequence.reduce((result, range, index, ranges) => {
    if (ranges[index - 1] && ranges[index - 1] === range) {
      // TODO (noahlaux): refactor according to https://github.com/eslint/eslint/issues/9670#issuecomment-348228268
      // eslint-disable-next-line no-param-reassign
      result[result.length - 1] += range
    } else {
      result.push(range)
    }

    return result
  }, [])
}

export default zipByRepetition
